import { createStore } from '@stencil/store';

export const SectionStore = createStore(<{ section: IWCSectionVisibility }>{
  section: {
    landing: true,
    tickets: false,
    ticket_details: false,
    ticket_close: false,
    chat: false,
    faq_list: false,
    faq_item: false,
    technical_emergency: false,
    contact_reception: false,
    contact_list: false,
    contact_phone: false,
    contact_callmeback: false,
    contact_chat: false,
    contact_mail: false,
    contact_mail_jelastic: false,
    contact_mail_success: false,
    contact_mail_error: false,
    error_default: false,
    error_unauthorized: false,
    alert_continue: false,
    alert_incident: false,
  },
});
